import {
  POST_ADD_ATTACHMENTS,
  REMOVE_SELECTED_ATTACHMENT,
  RESET,
  SET_DRAWINGS_LIST,
  SET_IS_FETCHING,
  SET_IS_PRINTING,
  SET_IS_PRODUCT_HAS_NO_PRICE_ALERT_OPEN,
  SET_ORDER_ATTACHMENTS,
  SET_SELECTED_ATTACHMENTS,
  UPDATE_SELECTED_ATTACHMENTS,
} from "./orderAttachments.actionTypes";

const initialState = {
  isFetching: false,
  isPrinting: false,
  attachments: [],
  selectedAttachments: [],
  newUploadedAttachments: [],
  drawingsList: null,
  isProductHasNoPriceAlertOpen: false,
  isInvoiceEmail: false,
  isInvoicePreview: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_IS_FETCHING: {
      return { ...state, isFetching: action.payload };
    }

    case SET_IS_PRINTING: {
      return { ...state, isPrinting: action.payload };
    }

    case `${SET_ORDER_ATTACHMENTS}`: {
      const attachments = action.payload.data;
      return { ...state, attachments };
    }

    case SET_SELECTED_ATTACHMENTS: {
      return {
        ...state,
        selectedAttachments: state.selectedAttachments.concat([
          { id: action.payload.id, type: action.payload.type, fullUrl: action.payload.fullUrl },
        ]),
      };
    }

    case SET_DRAWINGS_LIST: {
      return {
        ...state,
        drawingsList: action.payload,
      };
    }

    case SET_IS_PRODUCT_HAS_NO_PRICE_ALERT_OPEN: {
      return {
        ...state,
        isProductHasNoPriceAlertOpen: action.payload.status,
        isInvoiceEmail: action.payload.isInvoiceEmail,
        isInvoicePreview: action.payload.isInvoicePreview,
      };
    }

    case `${POST_ADD_ATTACHMENTS}/fulfilled`: {
      return { ...state, newUploadedAttachments: action.payload };
    }

    case REMOVE_SELECTED_ATTACHMENT: {
      const newList = state.selectedAttachments.filter((item) => item.id !== action.payload.id);
      return { ...state, selectedAttachments: newList };
    }

    case UPDATE_SELECTED_ATTACHMENTS: {
      return { ...state, selectedAttachments: action.payload };
    }

    case RESET: {
      return { ...initialState };
    }

    default:
      return state;
  }
};
